import React, { lazy } from "react";
import { Switch, Route } from "react-router-dom";
import {
  FORGOT,
  FORGOT_ORGANIZATION,
  LOGIN,
  RESET,
  VISION
} from "../constants/routeConstants";

const Login = lazy(() => import("../pages/Login"));
const PublicVision = lazy(() => import("../pages/PublicVision"));
const ErrorPage = lazy(() => import("../components/widgets/ErrorPage"));

const PublicRoutes = props => {
  return (
    <Switch>
      <Route
        path="/"
        exact
        render={propsData => (
          <Login
            {...propsData}
            initializeAWSConfig={props.initializeAWSConfig}
            checkUser={props.checkUser}
            publicClient={props.publicClient}
            forgot={false}
          />
        )}
      />
      <Route
        path={`${LOGIN}/:base64`}
        render={propsData => (
          <Login
            {...propsData}
            initializeAWSConfig={props.initializeAWSConfig}
            checkUser={props.checkUser}
            publicClient={props.publicClient}
            forgot={false}
            login={true}
          />
        )}
      />
      <Route
        path={FORGOT}
        exact
        render={propsData => (
          <Login
            {...propsData}
            initializeAWSConfig={props.initializeAWSConfig}
            checkUser={props.checkUser}
            publicClient={props.publicClient}
            forgot={true}
          />
        )}
      />
      <Route
        path={RESET}
        exact
        render={propsData => (
          <Login
            {...propsData}
            initializeAWSConfig={props.initializeAWSConfig}
            checkUser={props.checkUser}
            publicClient={props.publicClient}
            forgot={true}
          />
        )}
      />
      <Route
        path={FORGOT_ORGANIZATION}
        exact
        render={propsData => (
          <Login
            {...propsData}
            initializeAWSConfig={props.initializeAWSConfig}
            checkUser={props.checkUser}
            forgot={false}
            forgotOrganization={true}
            publicClient={props.publicClient}
          />
        )}
      />
      <Route
        path={`${VISION}/:visionId`}
        exact
        render={propsData => (
          <PublicVision
            {...propsData}
            initializeAWSConfig={props.initializeAWSConfig}
            publicClient={props.publicClient}
            isPublic={true}
          />
        )}
      />
      <Route render={() => <ErrorPage errorCode="401" />} />
    </Switch>
  );
};

export default PublicRoutes;
